"use client";

import { ArrowRight, Check } from "lucide-react";

import { HeroV2AvatarStack } from "./HeroV2AvatarStack";
import { MarketingTrackedLink } from "../MarketingTrackedLink";

type HeroV2CTAsProps = {
  primaryLabel: string;
  signupCounter: {
    countLabel: string;
    suffix: string;
  };
  trustItems: readonly string[];
};

export function HeroV2CTAs({
  primaryLabel,
  signupCounter,
  trustItems,
}: HeroV2CTAsProps) {
  return (
    <div className="mt-8 text-center">
      <div className="flex justify-center">
        <MarketingTrackedLink
          href="/sign-up"
          ctaId="hero_primary"
          ctaLabel={primaryLabel}
          id="hero-primary-cta"
          className="inline-flex h-14 w-full max-w-[360px] items-center justify-center gap-3 rounded-full bg-[#08A62F] px-4 text-[15px] font-bold text-white shadow-[0_18px_34px_-22px_rgba(8,166,47,0.95)] transition-colors duration-150 hover:bg-[#0BB63B] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-green-700 sm:px-6 sm:text-lg"
        >
          <span className="whitespace-nowrap leading-none">{primaryLabel}</span>
          <ArrowRight className="h-5 w-5 shrink-0" strokeWidth={2.6} aria-hidden />
        </MarketingTrackedLink>
      </div>

      <div className="mt-5">
        <HeroV2AvatarStack />

        <p className="text-sm font-medium text-slate-500 sm:text-[15px]">
          Join{" "}
          <span className="font-black text-[#08A62F]">
            {signupCounter.countLabel}
          </span>{" "}
          {signupCounter.suffix}
        </p>
      </div>

      <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium text-slate-600 sm:text-[15px]">
        {trustItems.map((item, index) => (
          <span key={item} className="inline-flex items-center gap-2.5">
            <Check
              className="h-4 w-4 text-[#08A62F]"
              strokeWidth={3}
              aria-hidden
            />
            <span>{item}</span>
            {index < trustItems.length - 1 ? (
              <span
                className="hidden h-1 w-1 rounded-full bg-green-200 sm:inline-block"
                aria-hidden
              />
            ) : null}
          </span>
        ))}
      </div>
    </div>
  );
}
